/* unplugin-vue-components disabled */import { render } from "./goodsGrid.vue?vue&type=template&id=7c473802&scoped=true"
import script from "./goodsGrid.vue?vue&type=script&lang=js"
export * from "./goodsGrid.vue?vue&type=script&lang=js"

import "./goodsGrid.vue?vue&type=style&index=0&id=7c473802&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c473802"]])

export default __exports__